







































































































































import { Component, Prop } from 'vue-property-decorator';
import {
  CheckIcon,
  FileTextIcon,
  PlusIcon,
  SettingsIcon,
  TrashIcon,
  UploadIcon,
  EditIcon,
  MoveIcon,
  CopyIcon,
} from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { GoalValueType, IGoal, IGoalResult, PolicyFilter } from 'admiral-core';
import CreateGoalModal from '@/views/pages/fivgoals/CreateGoalModal.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import TeamGoalRow from '@/views/pages/fivgoals/TeamGoalRow.vue';
import CreateGoalCurrentValueModal from '@/views/pages/fivgoals/CreateGoalCurrentValueModal.vue';
import PoliciesModal from '@/modals/PoliciesModal.vue';
import ContextMenu from '@/components/common/ContextMenu.vue';
import EditGoalValueModal from '@/views/pages/fivgoals/EditGoalValueModal.vue';
import EditGoalModal from '@/views/pages/fivgoals/EditGoalModal.vue';
import { Util } from '@/utils/Util';
import AgencyGoalProgress from '@/views/pages/fivgoals/components/AgencyGoalProgress.vue';
import { BModal } from 'bootstrap-vue';
import { GoalApi } from '@/services/GoalApi';
import dayjs from 'dayjs';

@Component({
  computed: {
    GoalValueType() {
      return GoalValueType;
    },
  },
  components: {
    AgencyGoalProgress,
    EditGoalModal,
    EditGoalValueModal,
    ContextMenu,
    PoliciesModal,
    CreateGoalCurrentValueModal,
    TeamGoalRow,
    CreateGoalModal,
    UploadIcon,
    PlusIcon,
    FileTextIcon,
    SettingsIcon,
    TrashIcon,
    CheckIcon,
    EditIcon,
    MoveIcon,
    CopyIcon,
  },
})
export default class TeamGoalTable extends mixins(BaseMixin, PermissionMixin) {
  @Prop({
    required: true,
    type: Object,
  })
  goal!: IGoal;

  @Prop({ required: false, type: String, default: 'agency' })
  readonly type!: IGoal['type'];

  @Prop({ required: false, type: Boolean, default: () => true })
  hasHandle!: boolean;

  selectedGoal: IGoal | null = null;
  selectedPoliciesModalFilter: PolicyFilter = {};
  result: IGoalResult | null = null;

  async mounted() {
    await this.loadGoalResult();
  }

  async loadGoalResult() {
    try {
      const response = await GoalApi.getGoalResult(
        this.goal.id,
        this.selectedPoliciesModalFilter.businessYear || new Date().getFullYear(),
      );
      this.result = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  getDaysCompleted() {
    return dayjs().diff(dayjs(this.goal.from), 'day');
  }
  getDaysTotal() {
    return dayjs(this.goal.to).diff(dayjs(this.goal.from), 'day');
  }

  isGoalCompleted() {
    return this.getDaysCompleted() >= this.getDaysTotal();
  }

  get totalValue() {
    return this.goal.value || 0;
  }

  get policedValue() {
    if (this.goal.valueType === GoalValueType.Valuation) {
      return Math.round(this.result?.policedValue || 0);
    } else if (this.goal.valueType === GoalValueType.Quantity) {
      return Math.round(this.result?.policedQuantity || 0);
    } else if (this.goal.valueType === GoalValueType.Jahresnettobeitrag) {
      return Math.round(this.result?.policedJahresNettoBeitrag || 0);
    }

    return 0;
  }

  get submittedValue() {
    if (this.goal.valueType === GoalValueType.Valuation) {
      return Math.round(this.result?.submittedValue || 0);
    } else if (this.goal.valueType === GoalValueType.Quantity) {
      return Math.round(this.result?.submittedQuantity || 0);
    } else if (this.goal.valueType === GoalValueType.Jahresnettobeitrag) {
      return Math.round(this.result?.submittedJahresNettoBeitrag || 0);
    }
    return 0;
  }

  get openValue() {
    if (this.goal.valueType === GoalValueType.Valuation) {
      return Math.round(this.result?.openValue || 0);
    } else if (this.goal.valueType === GoalValueType.Quantity) {
      return Math.round(this.result?.openQuantity || 0);
    } else if (this.goal.valueType === GoalValueType.Jahresnettobeitrag) {
      return Math.round(this.result?.openJahresNettoBeitrag || 0);
    }
    return 0;
  }

  get openValueAbove70() {
    if (this.goal.valueType === GoalValueType.Valuation) {
      return Math.round(this.result?.openValueAbove70 || 0);
    } else if (this.goal.valueType === GoalValueType.Quantity) {
      return Math.round(this.result?.openQuantityAbove70 || 0);
    } else if (this.goal.valueType === GoalValueType.Jahresnettobeitrag) {
      return Math.round(this.result?.openJahresNettoBeitragAbove70 || 0);
    }
    return 0;
  }

  get openValueBelow70() {
    if (this.goal.valueType === GoalValueType.Valuation) {
      return Math.round(this.result?.openValueBelow70 || 0);
    } else if (this.goal.valueType === GoalValueType.Quantity) {
      return Math.round(this.result?.openQuantityBelow70 || 0);
    } else if (this.goal.valueType === GoalValueType.Jahresnettobeitrag) {
      return Math.round(this.result?.openJahresNettoBeitragBelow70 || 0);
    }
    return 0;
  }

  get goalPeriodFrom() {
    return Util.formatDate2(this.goal.from);
  }

  get goalPeriodTo() {
    return Util.formatDate2(this.goal.to);
  }

  get timeValueTooltip() {
    if (this.isGoalCompleted()) {
      return '';
    }
    return `Nach ${this.getDaysCompleted()} von ${this.getDaysTotal()} Tagen`;
  }
  get timeValue() {
    if (this.goal.value) {
      return Math.round(Util.relativeValue(this.goal.value, this.goal.from, this.goal.to));
    }
    return 0;
  }

  async openAddGoalCurrentValueModal(goal: IGoal) {
    this.selectedGoal = goal;
    (this.$refs['create-goal-current-value-modal'] as any).$refs[
      'create-goal-current-value'
    ].show();
  }
  async openUpdateGoalValueModal(goal: IGoal) {
    this.selectedGoal = goal;
    (this.$refs['edit-goal-value-modal'] as any).$refs['edit-goal-value'].show();
  }
  openEditGoal() {
    (this.$refs['edit-goal-modal'] as any).$refs['edit-goal'].show();
  }

  openPoliciesModal(filter: PolicyFilter & { columns?: string[] }) {
    this.selectedPoliciesModalFilter = filter;
    (this.$refs['policies-modal'] as any).$refs['policies-modal'].show();
  }

  get productsStr() {
    if (this.goal.products.length === this.products.length) {
      return 'Alle Produkte';
    }

    if (this.goal.products.length === 1) {
      return this.goal.products[0].name;
    }

    if (this.goal.products.length === 2) {
      return `${this.goal.products[0].name} und ${this.goal.products[1].name}`;
    }

    return `${this.goal.products[0].name} und ${this.goal.products.length - 1} weitere`;
  }

  editGoal() {
    (this.$refs['modal-delete'] as BModal).show();
  }

  get isCurrentUserGoalUser() {
    return this.goal.user?.id === this.user.id;
  }
}
